import checkStopType from "@/lib/stopTypeChecker";
import { StopSearch } from "@catchy/ui";
import useLocalStorage from "hooks/useLocalStorage";
import { getMapCenterDefault } from "@/lib/regions/client";
const resolveStopType = (stop, type) => stop.stop_type || checkStopType(stop.stop_id) || type;
export default function Search(props) {
  const {
    center
  } = getMapCenterDefault();
  return <StopSearch {...props} searchType={props.type === "cable_car" ? "cablecar" : props.type} useLocalStorage={useLocalStorage} favouritesStorageKey="favourites" resolveStopType={resolveStopType} fallbackLocation={{
    latitude: center.lat,
    longitude: center.lng
  }} searchDescriptions={false} showStopIdentifier={(_stop, type) => type === "bus"} placeholder={props.type === "bus" ? "Search bus stops" : "Search train stations"} />;
}